'use client'
import { useCallback, useEffect, useState, useRef } from 'react'
import Link from 'next/link'
import cn from 'classnames'
import { useBoolean, useClickAway } from 'ahooks'
import { useSelectedLayoutSegment } from 'next/navigation'
import { Bars3Icon } from '@heroicons/react/20/solid'
import HeaderBillingBtn from '../billing/header-billing-btn'
import AccountDropdown from './account-dropdown'
import MarketNav from './market-nav'
import EcsNav from './ecs-nav'
import TrainNav from './train-nav'
import DeployNav from './deploy-nav'
import MaasNav from './maas-nav'
import s from './index.module.css'
import { WorkspaceProvider } from '@/context/workspace-context'
import { useAppContext } from '@/context/app-context'
import { useSiteContext } from '@/context/site-context'
import useBreakpoints, { MediaType } from '@/hooks/use-breakpoints'
import { useProviderContext } from '@/context/provider-context'
import { useModalContext } from '@/context/modal-context'
import { useConfigContext } from '@/context/config-context'

const navClassName = `
  flex items-center relative mr-0 sm:mr-3 px-3 h-8 rounded-xl
  font-medium text-sm
  cursor-pointer
`

const Header = () => {
  const site = useSiteContext()
  const [showUpgradePanel, setShowUpgradePanel] = useState(false)
  const upgradeBtnRef = useRef<HTMLElement>(null)
  useClickAway(() => {
    setShowUpgradePanel(false)
  }, upgradeBtnRef)
  const { isCurrentWorkspaceManager } = useAppContext()
  const { isCurrentWorkspaceEditor } = useAppContext()
  const config = useConfigContext()

  const selectedSegment = useSelectedLayoutSegment()
  const media = useBreakpoints()
  const isMobile = media === MediaType.mobile
  const [isShowNavMenu, { toggle, setFalse: hideNavMenu }] = useBoolean(false)
  const { enableBilling, plan } = useProviderContext()
  const { setShowPricingModal, setShowAccountSettingModal } = useModalContext()
  const isFreePlan = plan.type === 'sandbox'
  const handlePlanClick = useCallback(() => {
    if (isFreePlan)
      setShowPricingModal()
    else
      setShowAccountSettingModal({ payload: 'billing' })
  }, [isFreePlan, setShowAccountSettingModal, setShowPricingModal])

  useEffect(() => {
    hideNavMenu()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSegment])
  return (
    <div className='flex flex-1 items-center justify-between px-4'>
      <div className='flex items-center'>
        {isMobile && <div
            className='flex items-center justify-center h-8 w-8 cursor-pointer'
          onClick={toggle}
        >
          <Bars3Icon className="h-4 w-4 text-gray-500" />
        </div>}
        {!isMobile && <div className='flex items-center'>
            <Link href='/' className='flex items-center ml-4 mr-4'>
              <div className={cn(s[site.logo_cn], 'mr-2')}></div>
              {/* <LogoSite className='object-contain' /> */}
              {site.show_name && <span className={cn(s['site-name'], 'text-xl')}>
                {site.name}
              </span>}
            </Link>
            {/* <GithubStar /> */}
            <MarketNav className={navClassName} />
            {config.mlops.ecs.enabled && <EcsNav className={navClassName} />}
            {config.mlops.train.enabled && <TrainNav className={navClassName} />}
            {config.mlops.deploy.enabled && <DeployNav className={navClassName} />}
            {config.maas?.enabled && <MaasNav className={navClassName} />}
            
        </div>}
      </div>
      {isMobile && (
        <div className='flex'>
          <Link href="/apps" className='flex items-center mr-4'>
            <div className={cn(s[site.logo_cn])}></div>
            {/* <LogoSite /> */}
          </Link>
          {/* <GithubStar /> */}
        </div>
      )}
      <div className='flex items-center flex-shrink-0'>
        {/* <EnvNav /> */}
        {enableBilling && (
          <div className='mr-3 select-none'>
            <HeaderBillingBtn onClick={handlePlanClick} />
          </div>
        )}
        <WorkspaceProvider>
          <AccountDropdown isMobile={isMobile} />
        </WorkspaceProvider>
      </div>
      {(isMobile && isShowNavMenu) && (
        <div className='w-full flex flex-col p-2 gap-y-1'>
          <MarketNav className={navClassName} />
          <EcsNav className={navClassName} />
          <TrainNav className={navClassName} />
          <DeployNav className={navClassName} />
          <MaasNav className={navClassName} />
        </div>
      )}
    </div>
  )
}
export default Header
